function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 12.25H2.5C2.0875 12.25 1.75 11.9125 1.75 11.5V2.5C1.75 2.0875 2.0875 1.75 2.5 1.75H6.25C6.6625 1.75 7 1.4125 7 1C7 0.5875 6.6625 0.25 6.25 0.25H1.75C0.9175 0.25 0.25 0.925 0.25 1.75V12.25C0.25 13.075 0.925 13.75 1.75 13.75H12.25C13.075 13.75 13.75 13.075 13.75 12.25V7.75C13.75 7.3375 13.4125 7 13 7C12.5875 7 12.25 7.3375 12.25 7.75V11.5C12.25 11.9125 11.9125 12.25 11.5 12.25ZM8.5 1C8.5 1.4125 8.8375 1.75 9.25 1.75H11.1925L4.345 8.5975C4.0525 8.89 4.0525 9.3625 4.345 9.655C4.6375 9.9475 5.11 9.9475 5.4025 9.655L12.25 2.8075V4.75C12.25 5.1625 12.5875 5.5 13 5.5C13.4125 5.5 13.75 5.1625 13.75 4.75V1C13.75 0.5875 13.4125 0.25 13 0.25H9.25C8.8375 0.25 8.5 0.5875 8.5 1Z",
  fill: "#086B9C"
});

var SvgExternalLinkIcon = function SvgExternalLinkIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExternalLinkIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/external_link_icon.180122e2.svg";
export { ForwardRef as ReactComponent };